import React from "react";

function Tooltip({ text, children }) {
  return (
    <div className="tooltip-container">
      {children}
      {text && (
        <span className="tooltip-text" >
          {text}
        </span>
      )}
    </div>
  );
}

export default Tooltip;
